module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<fieldset class="referentielhabr-selecteurref" class="habr-selecteur-view-size">\r\n  <fieldset class="habr-selecteur-view-size">\r\n    <legend>\r\n      '+
((__t=(i18n.t('habr.legend_selectref_criteres')))==null?'':__t)+
'\r\n    </legend>\r\n    <div class="form-group col-12">\r\n      <input type="text" class="criteres habr-selecteur-view-size form-control ui-autocomplete-input" title="" value="" />\r\n    </div>\r\n  </fieldset>\r\n  <div class="table_selecteurref_referentielhabr"></div>\r\n</fieldset>\r\n';
}
return __p;
};
